import LeadFormSGIP from './lead_form_sgip';
export default LeadFormSGIP;
